// src/utils/tokenManager.js
let accessToken = null;
let tokenExpiry = null;

// Optional: prevent multiple simultaneous calls if lots of requests fire at once
let inFlightPromise = null;

export async function getAccessToken() {
  const now = Date.now();

  // ✅ Use cached token if still valid (60s safety)
  if (accessToken && tokenExpiry && now < tokenExpiry - 60_000) {
    return accessToken;
  }

  // ✅ Deduplicate concurrent callers
  if (inFlightPromise) return inFlightPromise;

  inFlightPromise = (async () => {
    const resp = await fetch("/api/neuron/token", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!resp.ok) {
      const text = await resp.text().catch(() => "");
      throw new Error(`Failed to fetch access token from server: ${text}`);
    }

    const data = await resp.json();

    if (!data?.access_token) {
      throw new Error("Token endpoint did not return access_token");
    }

    accessToken = data.access_token;

    // ✅ Prefer real expiry if your API returns expires_in
    if (typeof data.expires_in === "number") {
      tokenExpiry = Date.now() + data.expires_in * 1000;
    } else {
      // Fallback: short client cache (server caches properly)
      tokenExpiry = Date.now() + 10 * 60 * 1000;
    }

    return accessToken;
  })();

  try {
    return await inFlightPromise;
  } finally {
    inFlightPromise = null;
  }
}
